export const LOGGED_ON_INFO_LABEL_LOAD = 'LOGGED_ON_INFO_LABEL_LOAD';
export const LOGGED_ON_INFO_LABEL_ERROR = 'LOGGED_ON_INFO_LABEL_ERROR';